import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../services/instance";
import { endpoints } from "../../constants/endpoints";
import { toast } from "react-toastify";

export const professionalUserUpdateAPI = createAsyncThunk(
    "professionalUserUpdateAPI",
    async (data, { rejectWithValue }) => {
        try {
            const id = data.get('id')
            const response = await api.post(endpoints.updateProfessionalProfile(id), data, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
            return response;
        } catch (error) {
            if (error.response && error.response.data) {
                return rejectWithValue(error.response.data);
            }
            return rejectWithValue({ message: 'Something went wrong' });
        }
    }
);


const initialState = {
    loading: false
}

const professionalUserUpdateSlice = createSlice({
    initialState,
    name: "professionalUserUpdateSlice",
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(professionalUserUpdateAPI.pending, (state, action) => {
            state.loading = true
        })

        builder.addCase(professionalUserUpdateAPI.fulfilled, (state, action) => {
            state.loading = false;
            localStorage.setItem("user", JSON.stringify(action?.payload?.data?.data));
            // toast.success("Profile Update Successfully")
        })

        builder.addCase(professionalUserUpdateAPI.rejected, (state, action) => {
            state.loading = false
        })
    }
})

export const { } = professionalUserUpdateSlice.actions
export default professionalUserUpdateSlice.reducer